import { render, staticRenderFns } from "./company-footer.vue?vue&type=template&id=34a51c4c&scoped=true&"
import script from "./company-footer.vue?vue&type=script&lang=ts&"
export * from "./company-footer.vue?vue&type=script&lang=ts&"
import style0 from "./company-footer.vue?vue&type=style&index=0&id=34a51c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a51c4c",
  null
  
)

export default component.exports